import { ReducerAction } from 'store/modules/types';

import { Types, IRequestEnderecos } from './types';

export function consultaEnderecosRequest(
	data: IRequestEnderecos,
): ReducerAction {
	return {
		type: Types.CONSULTA_ENDERECOS,
		payload: data,
	};
}
export function consultaEnderecosSuccess(payload: object): ReducerAction {
	return {
		type: Types.CONSULTA_ENDERECOS_SUCCESS,
		payload,
	};
}
export function consultaEnderecosFailure(): ReducerAction {
	return {
		type: Types.CONSULTA_ENDERECOS_FAILURE,
		payload: null,
	};
}
